import styled from "styled-components";
export const Section = styled.div `
  margin-top: 64px;
`;
export const ItemsList = styled.ul `
  padding: 0;
  margin: 0;
`;
export const Item = styled.li `
  list-style-type: none;
  font-size: 16px;
  padding: 4px 8px;
  margin-bottom: 8px;
`;
